module.exports = __webpack_public_path__ + "img/check.a77c6967.svg";